import { RouteConfig } from 'vue-router';
import NotificationCenterComponent from './notification-center.component.vue';

export const NotificationCenterRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'alerts',
  component: NotificationCenterComponent,
};

export function getDefaultParams() {
  return {};
}
